import { gql } from '@apollo/client'

const fetchArticles = gql`
  query listeArticles {
    articles {
      nodes {
        id
        label
        pricesByIdArticle {
          nodes {
            id
            value
          }
        }
      }
    }
  }
`
export default fetchArticles
